module.exports = __webpack_public_path__ + "static/media/มะเมีย.708d313a.jpg";